import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServerUrlService } from './server-url.service';
import { ParametrosService } from './parametros.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestingPhysicianService {

  constructor(
    private http: HttpClient,
    private parametrosService: ParametrosService

  ) {}

  getRequestingPhysicians(params: any): Observable<any> {
    const nodeServer = this.parametrosService.getNodeParams('REC_NODE_SERVER')
    return this.http.post(`${nodeServer}/profmedsolicitante/get`, params);
  }
}
